var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    rx: 5,
    fill: "#D4DFE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5106 20.263H9.9248V14.1644C9.9248 11.2423 12.2918 8.86768 15.2216 8.86768C18.1436 8.86768 20.5183 11.2346 20.5183 14.1644V20.263H20.5106Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22864 20.2632H22.2068",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7713 21.7974C16.7713 22.6532 16.0774 23.3548 15.2139 23.3548C14.3504 23.3548 13.6565 22.6609 13.6565 21.7974",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6864 10.7183C22.6864 12.5712 21.1843 14.0733 19.3314 14.0733C17.4785 14.0733 15.9764 12.5712 15.9764 10.7183C15.9764 8.86536 17.4785 7.36328 19.3314 7.36328C21.1843 7.36328 22.6864 8.86536 22.6864 10.7183Z",
    fill: "#C51F1F",
    stroke: "#F6F5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSmall);
export default __webpack_public_path__ + "static/media/bell-small.9ede61b1926aefa3ebf6b035f63666fc.svg";
export { ForwardRef as ReactComponent };